<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="5">
					<search-plant-select></search-plant-select>
				</el-col>
				<el-col :span="4">
					<search-input :label="getMessage_('MWCC000104')" paramKey="permGrpCd" @commInput="onChangeInput"></search-input>
				</el-col>
				<el-col :span="4">
					<search-input :label="getMessage_('MWCC000105')" paramKey="userGrpName" @commInput="onChangeInput"></search-input>
				</el-col>
				<el-col :span="5">
					<search-useYn-select @search="searchList"></search-useYn-select>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/GridFreeForm/store/helpers';
import SearchInput from '@qms/Components/SearchInput.vue';
import SearchPlantSelect from './SearchPlantSelect.vue';
import SearchUseYnSelect from './SearchUseYnSelect.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	components: { SearchInput, SearchPlantSelect, SearchUseYnSelect },
	async created() {
		try {
			await this.getPlants_();
			await this.getCommCodes_({ key: 'useYnList', codeType: 'USE_YN' });
			let list = [];
			this.useYnList.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
			await this.setState_({ key: 'gridUseYnList', value: list });
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message || error
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async searchList() {
			try {
				this.$sf_toggleLoading(true);
				await this.getGroups_();
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error.message || error
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		onChangeInput(param) {
			this.setState_(param);
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
